<template>
  <div class="top">
    <div class="top-button is-left">
      <div class="tags-breadcrumb">
        <i class="icon-navicon tag-collapse" :class="[{ 'tag-collapse_right': isCollapse }]" @click="showCollapse"></i>
      </div>
    </div>
    <breadcrumb></breadcrumb>
    <div class="top-title">
    </div>

    <div class="top-button is-right">
      <el-tooltip class="item" effect="dark" v-if="statecompany == false" content="企业名称" placement="bottom">
        <span class="top-item" style="color: #919191;font-size: 15px;">
         {{company.name}}
        </span>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" v-if="!isPlatformUser" content="认证状态" placement="bottom" >
        <span class="top-item" style="color: #919191;font-size: 15px;" v-if="adminstate == true">
         <a :href="url" style="text-decoration none;">{{setstate(this.$store.getters.getCompanyState)}}</a>
        </span>
        <span class="top-item" style="color: #919191;font-size: 15px;" v-else>
         {{setstate(this.$store.getters.getCompanyState)}}
        </span>
      </el-tooltip>
      <el-tooltip class="item" effect="dark"  v-if="!isPlatformUser" content="二维码" placement="bottom" >
        <img src="./xcx.jpg" @click="showimg" v-if="openid.length>0" style="width: 30px;margin: 0 15px;">
        <img :src="imgurlgzh" @click="showgzh" v-else style="width: 30px;margin: 0 15px;">
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="主题色" placement="bottom">
        <span class="top-item">
          <top-theme></top-theme>
        </span>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="锁屏" placement="bottom">
        <span class="top-item">
          <top-lock></top-lock>
        </span>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" :content="isFullScren?'退出全屏':'全屏'" placement="bottom">
        <span class="top-item">
          <i :class="isFullScren?'icon-tuichuquanping':'icon-quanping'" @click="handleScreen"></i>
        </span>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="用户头像" placement="bottom">
        <img class="top-userImg" :src="userInfo.avatar">
      </el-tooltip>
      <el-dropdown>
        <span class="el-dropdown-link">
          {{userInfo.name}}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <router-link to="/">首页</router-link>
          </el-dropdown-item>
          <el-dropdown-item>
            <router-link to="/info/index">个人信息</router-link>
          </el-dropdown-item>
          <el-dropdown-item @click.native="logout" divided>退出系统</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
     <el-dialog title="二维码" :visible.sync="dialogInvite"  width="30%" >
        <div class="container" style="text-align: center;">
            <img src="./xcx.jpg" style="width:300px;"/>
            <p style="text-align: center;margin: 15px;">您可以进入小程序随时进行操作</p>
        </div>
    </el-dialog>
     <el-dialog title="二维码" :visible.sync="dialogInvitegzh"  width="30%" >
        <div class="container" style="text-align: center;">
            <img :src="imgurlgzh" style="width:300px;"/>
            <p style="text-align: center;margin: 15px;">扫描二维码绑定微信,继续更多操作</p>
        </div>
    </el-dialog>
  </div>

</template>
<script>
import { mapState, mapGetters } from 'vuex'
import {logout} from '@/api/admin/login'
import {getewm} from '@/api/admin/business'
import { objKeySort } from '@/util/ajaxsign'
import topLock from './top-lock'
import topMenu from './top-menu'
import topTheme from './top-theme'
import Breadcrumb from './top-breadcrumb'
import {fullscreenToggel, listenfullscreen} from '@/util/util'
import {getImgLink,getImgLinksplit,apiLink} from '@/config/env'
export default {
  components: { Breadcrumb, topLock, topMenu, topTheme },
  name: 'top',
  data() {
    return {
      company : {},
      adminstate : false,
      url : '',
      statecompany : false,
      imgurl : "./xcx.jpg",
      imgurlgzh : '',
      openid : '',
      dialogInvite : false,
      dialogInvitegzh : false,
      dialogInfo: false,
      isPlatformUser:false,
      closeDialog:false,
      userInfo:{}
    }
  },
  filters: {},
  created() {
     this.getcompany();
     this.getgzh();
  },
  mounted() {
    listenfullscreen(this.setScreen)
  },
  computed: {
    // ...mapState({
    //   userInfo: state => state.user.userInfo
    // }),
    ...mapGetters(['isFullScren', 'isCollapse','companyState'])
  },
  methods: {
    //获取企业信息
    getcompany(){
      var opendata = JSON.parse(window.sessionStorage.getItem("userInfo"))
      this.userInfo = opendata;
      console.log(this.userInfo);
      this.userInfo.avatar= opendata.avatar?getImgLink(opendata.avatar):opendata.headimgurl?opendata.headimgurl:'/img/default-avatar.png';
      this.openid = opendata.openId?opendata.openId:'';
      console.log(this.openid)
      if(opendata.userType == 1){
        this.company.name = '平台管理员';
        this.isPlatformUser = true;
      }else{
        this.isPlatformUser = false;
        this.company = JSON.parse(window.sessionStorage.getItem("userInfo")).company!=null?JSON.parse(window.sessionStorage.getItem("userInfo")).company:undefined;
      }

       if(this.company != undefined){
         if(this.company.userId == JSON.parse(window.sessionStorage.getItem("userInfo")).id){
          this.adminstate = true;
        }
       }

       if(this.company == undefined){
         this.statecompany = true;
       }
       if(this.company){
         this.$store.commit('SET_COMPANYSTATE', this.company.state);
       }
       this.url = window.location.href.split('#')[0]+"#/admin/legalize"
    },
    //设置企业状态
    setstate(data){
      //：0，未认证，1，审核中，2审核通过，3冻结
      if (data == 3) {
        return "已拒绝";
      } else if (data == 2) {
        return "已认证";
      } else if (data == 1) {
        return "审核中";
      } else if(data>=4){
        return "已冻结";
      }else{
        return "未认证";
      }
    },
    showCollapse() {
      this.$store.commit('SET_COLLAPSE')
    },
    handleScreen() {
      fullscreenToggel()
    },
    setScreen() {
      this.$store.commit('SET_FULLSCREN')
    },
    logout() {
      this.$confirm('是否退出系统, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        logout(objKeySort()).then(response => {
          sessionStorage.clear();
          window.location.href = window.location.href.split('#')[0]+"index/login.html"
        })
      })
    },

    //点击二维码
    showimg(){
      this.dialogInvite = true;
    },
    //点击展示公众号
    showgzh(){
      this.dialogInvitegzh = true;
    },

    //获取公众号二维码
    getgzh(){
      getewm(objKeySort()).then(response => {
        this.imgurlgzh = "data:image/png;base64,"+response.data.data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .tags-breadcrumb {
    padding-left: 0px;
  }
  .tags-breadcrumb-list {
    padding-left: 0px;
  }
  .top.is-right {
    float: right;
  }
  .item {
    cursor: pointer;
  }
</style>
